import React from 'react'
import styles from './GuidePageViewer.scss'
import { Editor, EditorState, convertFromRaw, CompositeDecorator } from 'draft-js'
import { findLinkEntities, findPlainTextLinks, findPlainTextEmails } from 'lib/draftUtils'
import { RouteBlockContent } from 'features/experiences/GuidePage/EditorColumn/GuidePageEditor/RouteBlock'
import p from 'prop-types'

const fromContent = (reportContent) => {
  return EditorState.createWithContent(convertFromRaw(reportContent), decorator)
}

export class GuidePageViewer extends React.PureComponent {
  static defaultProps = {
    guide: p.object.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      editorState: props.guide.content && fromContent(props.guide.content)
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.guide !== this.props.guide) {
      this.processGuideContent()
    }
  }

  processGuideContent = () => {
    console.log('‼️ procesGuideContent')
    this.setState({
      editorState: fromContent(this.props.guide.content)
    })
  }

  blockRenderer = (block) => {
    const mappings = {
      image: Image,
      route: Route,
      elevation: Elevation,
      separator: () => <hr />
    }
    if (block.getType() === 'atomic') {
      return {
        component: mappings[block.getData().get('type')],
        editable: false, // very important - prevents crash when user enters text in custom component div
        props: {}
      }
    }
    return null
  }

  render () {
    const { guide } = this.props
    const { editorState } = this.state

    if (!guide || !editorState) { return null }

    return (
      <div className={styles.GuidePageViewer}>
        {guide.content && <Editor readOnly
          editorState={editorState}
          blockRendererFn={this.blockRenderer} />}
      </div>
    )
  }
}

const Link = (props) => {
  const { url } = props.contentState.getEntity(props.entityKey).getData()
  return (
    <a href={url} target='_blank' rel='noopener'>
      {props.children}
    </a>
  )
}

const PlainLink = ({ decoratedText }) => (
  <a href={decoratedText} target='_blank' rel='noopener' data-plain-link>
    {decoratedText}
  </a>
)

const PlainEmail = ({ decoratedText }) => (
  <a href={`mailto:${encodeURIComponent(decoratedText)}`} target='_blank' rel='noopener' data-plain-link>
    {decoratedText}
  </a>
)

// this works without conflicts because CompositeDecorator just rolls with the
// matching decorator that it finds, and doesn't attempt to next or overlap
// decorators: https://github.com/facebook/draft-js/issues/1703
const decorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link
  },
  {
    strategy: findPlainTextEmails,
    component: PlainEmail
  },
  {
    strategy: findPlainTextLinks,
    component: PlainLink
  }
])

class Image extends React.PureComponent {
  render () {
    const data = this.props.block.getData()
    const photoId = data.get('photoId', null)
    const src = `/photos/${photoId}/large.jpg`

    return (
      <div>
        <img style={{ maxWidth: '100%' }} src={src} />
      </div>
    )
  }
}

class Route extends React.PureComponent {
  render () {
    const data = this.props.block.getData()
    const route = data.get('route', null)

    return route ? <RouteBlockContent route={route} onClick={() => {}} /> : null
  }
}

class Elevation extends React.PureComponent {
  render () {
    const data = this.props.block.getData()
    const routeId = data.get('routeId', null)
    const profileSrc = `/routes/elevation_profile/${routeId}.png`

    return (
      <div>
        <img style={{ maxWidth: '100%' }} src={profileSrc} />
      </div>
    )
  }
}
